import _ from 'lodash';
import React, {useContext} from 'react';
import {TableCell, TableRow, Table, TableBody} from '@material-ui/core';
import {Checkbox} from '@treez-ui/core/forms';
import {ProductInCatalog} from '@treez/commons/sharedTypings/product';
import {
    DispatchCurrentSelectionAction,
    CurrentSelectionStateContext,
    TypeOfSelectAction,
} from '~/lib/selectedProductContext';

const {ADD, REMOVE} = TypeOfSelectAction;

export const ActionBarProductTable = () => {
    const selectedProducts = useContext(CurrentSelectionStateContext);
    const dispatchSelection = DispatchCurrentSelectionAction();

    const handleSelect = (e: React.ChangeEvent<HTMLInputElement>, product: ProductInCatalog) => {
        dispatchSelection({
            type: e.target.checked ? ADD : REMOVE,
            products: [product],
        });
    };

    return (
        <Table>
            <TableBody>
                {_.map(selectedProducts, (product) => {
                    return (
                        <TableRow key={product.id}>
                            <TableCell>
                                <Checkbox checked onChange={(e) => handleSelect(e, product)} />
                            </TableCell>
                            <TableCell>{product.name}</TableCell>
                            <TableCell>{product.brandName}</TableCell>
                            <TableCell>{product.size}</TableCell>
                            <TableCell>
                                {Math.abs(Number(product.amount))}
                                {product.uom}
                            </TableCell>
                        </TableRow>
                    );
                })}
            </TableBody>
        </Table>
    );
};

export default ActionBarProductTable;
